import { Link } from "react-router-dom";

export const Logo = () => (
  <Link to="/" data-testid="logo-airthermo" className="flex items-center gap-2.5 min-h-[44px]">
    <span className="relative w-9 h-9 flex items-center justify-center" style={{ background: "var(--accent)", borderRadius: "12px" }}>
      <span className="w-3.5 h-3.5 at-pill" style={{ background: "var(--micro)" }} />
    </span>
    <span className="text-[1.35rem] font-bold tracking-tight leading-none">
      airthermo<span className="at-muted font-semibold text-sm ml-1 align-top">V2</span>
    </span>
  </Link>
);
